import { HttpPostRequest } from "./HttpRequest.js";

export async function all(payload, startDate, endDate) {
  let url = "/users/stats?start_at=" + startDate.format('YYYYMMDD') + '&end_at=' + endDate.format('YYYYMMDD');
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
